import { setupPlausible } from '../../components/plausible';
const formSelector = '.js-newsletter_recommendations_form';
const recommendationSelector = '.js-newsletter_recommendation';
const recommendationLinkSelector = '.js-newsletter_recommendation_link';
const selectAllSelector = '.js-newsletter_recommendations_select_all';
const checkboxSelector = 'input:not([disabled])[name="publication_ids[]"]';
const submitButtonSelector = '.js-newsletter_recommendations_form_submit';
window.up.compiler(recommendationSelector, (element) => {
    var _a, _b, _c;
    const { trackEvent } = setupPlausible();
    const checkbox = element.querySelector(checkboxSelector);
    if (checkbox) {
        trackEvent('Newsletter Recommendation Shown', {
            props: {
                page: (_a = checkbox.dataset.page) !== null && _a !== void 0 ? _a : '',
                recommendation_source_publication_id: (_b = checkbox.dataset.sourcePublicationId) !== null && _b !== void 0 ? _b : '',
                publication_id: checkbox.value,
                recommended_by: (_c = checkbox.dataset.recommendedBy) !== null && _c !== void 0 ? _c : ''
            }
        });
        const links = Array.from(element.querySelectorAll(recommendationLinkSelector));
        links.forEach(link => link.addEventListener('click', () => {
            var _a, _b, _c;
            trackEvent('Newsletter Recommendation Clicked', {
                props: {
                    page: (_a = checkbox.dataset.page) !== null && _a !== void 0 ? _a : '',
                    recommendation_source_publication_id: (_b = checkbox.dataset.sourcePublicationId) !== null && _b !== void 0 ? _b : '',
                    publication_id: checkbox.value,
                    recommended_by: (_c = checkbox.dataset.recommendedBy) !== null && _c !== void 0 ? _c : ''
                }
            });
        }));
    }
});
window.up.compiler(formSelector, (form) => {
    const { trackEvent } = setupPlausible();
    const button = form.querySelector(submitButtonSelector);
    const selectAll = form.querySelector(selectAllSelector);
    const allCheckboxes = Array.from(document.querySelectorAll(checkboxSelector));
    const updateSubmitAndSelectAllStates = () => {
        const uncheckedCheckboxes = allCheckboxes.filter(ch => !ch.checked);
        if (button) {
            button.disabled = uncheckedCheckboxes.length === allCheckboxes.length;
        }
        if (selectAll) {
            selectAll.disabled = allCheckboxes.length === 0;
            selectAll.checked = uncheckedCheckboxes.length === 0;
        }
    };
    if (selectAll) {
        selectAll.addEventListener('change', () => {
            allCheckboxes.forEach(ch => (ch.checked = selectAll.checked));
            updateSubmitAndSelectAllStates();
        });
    }
    if (button) {
        allCheckboxes.forEach(ch => ch.addEventListener('change', updateSubmitAndSelectAllStates));
        updateSubmitAndSelectAllStates();
        form.addEventListener('submit', () => {
            allCheckboxes
                .filter(ch => ch.checked)
                .forEach(checkbox => {
                var _a, _b, _c;
                return trackEvent('Newsletter Recommendation Subscribed', {
                    props: {
                        page: (_a = checkbox.dataset.page) !== null && _a !== void 0 ? _a : '',
                        recommendation_source_publication_id: (_b = checkbox.dataset.sourcePublicationId) !== null && _b !== void 0 ? _b : '',
                        publication_id: checkbox.value,
                        recommended_by: (_c = checkbox.dataset.recommendedBy) !== null && _c !== void 0 ? _c : ''
                    }
                });
            });
        });
    }
});
